import { createFileRoute } from '@tanstack/react-router';

import { getCommitteeOptions } from '@/module/Author/Committee';

export const Route = createFileRoute('/_auth/author/_author/committee/_committee/$committeeId/_layout')({
  loader: async ({ params: { committeeId }, context: { queryClient } }) => {
    const committee = await queryClient.ensureQueryData(getCommitteeOptions(committeeId));

    return {
      committee,
      crumb: committee.title,
    };
  },
});
